// extracted by mini-css-extract-plugin
export default {"placeholder":"Editor_placeholder__fZKHc","input":"Editor_input__38miy"};